// A firmware deploy target is either a padihat Device (plain MAC) or a greenhouse
// controller. The Config page's deploy modal keeps ONE "selected target" string,
// so a greenhouse controller is encoded as "greenhouse:<mac>".

export const GREENHOUSE_PRODUCT = "greenhouse-controller";
const GREENHOUSE_PREFIX = "greenhouse:";

export const encodeGreenhouseTarget = (mac) => `${GREENHOUSE_PREFIX}${mac}`;

export const parseDeployTarget = (value) => {
  if (typeof value === "string" && value.startsWith(GREENHOUSE_PREFIX)) {
    return { kind: "greenhouse", mac: value.slice(GREENHOUSE_PREFIX.length) };
  }
  return { kind: "device", mac: value || "" };
};

// Mirrors the backend's guards (the backend stays the authority): a greenhouse
// target takes only greenhouse-controller images; device targets take anything
// that does not declare itself greenhouse firmware (unmarked camera/PadiHAT
// images have a blank product).
export const firmwareFitsTarget = (firmware, kind) =>
  kind === "greenhouse"
    ? firmware.product === GREENHOUSE_PRODUCT
    : firmware.product !== GREENHOUSE_PRODUCT;

// Reasons the device (or backend) reports for a failed update, in plain words.
const OTA_FAILURES = {
  busy_pump: "The pump was running - stop it and try again.",
  wrong_product: "That image is not greenhouse-controller firmware.",
  version_mismatch: "The image's embedded version does not match the version deployed.",
  sha256_mismatch: "The downloaded file was corrupt (checksum mismatch).",
  size_mismatch: "The downloaded file was the wrong size.",
  download_timeout: "The download stalled - check the device can reach the firmware server.",
  rolled_back:
    "The new image did not reconnect to WiFi and MQTT in time, so the device rolled back to the previous version.",
  update_apply_failed: "The device could not write the new image to flash.",
  bad_url: "The device rejected the download link.",
  missing_sha256_or_size: "The update command was missing its checksum or size.",
};

export const describeOtaFailure = (reason) => {
  if (!reason) return "";
  if (OTA_FAILURES[reason]) return OTA_FAILURES[reason];
  if (reason.startsWith("download_failed")) {
    return "The device could not download the image - check it can reach the firmware server.";
  }
  return "";
};
